import type { UseMutationResult } from '@tanstack/react-query'
import { useIsMutating, useMutation } from '@tanstack/react-query'
import type { AxiosResponse } from 'axios'

import { getMfrrCapacityBid } from '@/features/bidding/endpoints/bids'
import type { UseMutationOptions } from '@/types/queries'

const GET_MFRR_CAPACITY_BID = 'GET_MFRR_CAPACITY_BID'

type GetMfrrCapacityBid = {
  countryCode: string
  deliveryDay: string // ISO date string
}

export type UseGetMfrrCapacityBidMutationResult = Omit<
  UseMutationResult<AxiosResponse<Blob>, Error, GetMfrrCapacityBid>,
  'mutateAsync'
> & {
  getMfrrCapacityBid: UseMutationResult<AxiosResponse<Blob>, Error, GetMfrrCapacityBid>['mutateAsync']
}

export function useGetMfrrCapacityBidMutation(
  options?: UseMutationOptions<AxiosResponse<Blob>, GetMfrrCapacityBid>,
): UseGetMfrrCapacityBidMutationResult {
  const { mutateAsync, ...mutationResult } = useMutation({
    ...options,
    mutationFn: (variables: GetMfrrCapacityBid) => getMfrrCapacityBid(variables.countryCode, variables.deliveryDay),
  })

  return { getMfrrCapacityBid: mutateAsync, ...mutationResult }
}

export const useIsGettingMfrrCapacityBid = (): boolean => useIsMutating({ mutationKey: [GET_MFRR_CAPACITY_BID] }) > 0
